import esg_grade_line_chart from '../components/ESGRatingLineChart'
import esg_industry_grade_bar_chart from '../components/ESGIndustryRatingBarChart'
import esg_grade_indication_table from '../components/ESGRatingIndicationTable'
import esg_industry_grade_table from '../components/ESGIndustryRatingTable'
import entity_search from '../../home/components/EntitySearch'
import Vue from 'vue'
import {reportYear} from '../../util/util'
let esg_industry_grade = {
  components: {esg_grade_line_chart, esg_industry_grade_bar_chart, esg_grade_indication_table, esg_industry_grade_table, entity_search},
  data: () => {
    return {
      report_year_list: [],
      year: null,
      industry: null,
      selectEvent:false,
      rating: null,
    }
  },
  methods: {
    generateReport(){
      let self = this
      reportYear.esg_report_month().then(result => {
            self.report_year_list =result.report_list
            self.year=self.report_year_list[0]
      })
    },
    selectIndustry(industry, rating){
      this.industry = industry
      this.rating = rating
      this.selectEvent = !this.selectEvent
    },

  },
  mounted () {
    this.generateReport()
  },
  watch: {
    year: function () {
      this.$store.commit('esg/esgReport', {year: this.year})
    }
  }

}
export default esg_industry_grade



// WEBPACK FOOTER //
// ./src/esg/js/esg_industry_rating.js